import {IconProps} from './types'

export default function RainyIcon({size = 16, ...props}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M2.66667 9.93272C2.17136 9.42667 1.79771 8.81453 1.57402 8.14268C1.35033 7.47083 1.28247 6.75688 1.37557 6.05492C1.46868 5.35296 1.7203 4.68139 2.1114 4.09108C2.50249 3.50077 3.02279 3.0072 3.63289 2.64776C4.24299 2.28831 4.92688 2.07242 5.63278 2.01644C6.33867 1.96046 7.04805 2.06585 7.70718 2.32463C8.36631 2.58341 8.9579 2.98879 9.43716 3.51008C9.91641 4.03136 10.2707 4.65488 10.4733 5.33339H11.6667C12.3103 5.33331 12.937 5.54027 13.454 5.92368C13.971 6.30709 14.351 6.84663 14.5378 7.46259C14.7247 8.07855 14.7085 8.73828 14.4916 9.3443C14.2747 9.95033 13.8686 10.4705 13.3333 10.8281"
        stroke="#6D6D6D"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.13333 14.6667L8.13333 10"
        stroke="#0054C2"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 8.66663L4 13.3333"
        stroke="#0054C2"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3333 8.66663L9.33334 13.3333"
        stroke="#0054C2"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
